module.exports = __webpack_public_path__ + "static/media/app_angular_firebase.148a599f.md";